import { render } from "./Faq.vue?vue&type=template&id=e3037ff6&scoped=true&ts=true"
import script from "./Faq.vue?vue&type=script&lang=ts"
export * from "./Faq.vue?vue&type=script&lang=ts"

import "./Faq.vue?vue&type=style&index=0&id=e3037ff6&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3037ff6"]])

export default __exports__